import React from "react";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";

//Import Icons
import Icon from "@ailibs/feather-react-ts";

//import images
import avatar2 from "../../../assets/images/users/avatar-2.jpg";
import avatar1 from "../../../assets/images/users/avatar-1.jpg";
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../../assets/images/users/avatar-5.jpg";
import avatar6 from "../../../assets/images/users/avatar-6.jpg";

const Team = ({ project }: any) => {
  return (
    <React.Fragment>
      <div>
        <Card>
          <CardBody>
            <Row>
              <Col xl={3} sm={6}>
                <Card className="border shadow-none">
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar-sm">
                          <div className="avatar-title bg-light text-primary rounded-circle font-size-18">
                            <i className="uil uil-users-alt"></i>
                          </div>
                        </div>
                      </div>

                      <div className="flex-grow-1 overflow-hidden">
                        <p className="mb-1 text-truncate text-muted">Equipa</p>
                        <h5 className="font-size-16 mb-0">Khozi Tech</h5>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xl={3} sm={6}>
                <Card className="border shadow-none">
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar-sm">
                          <div className="avatar-title bg-light text-primary rounded-circle font-size-18">
                            <i className="uil uil-user"></i>
                          </div>
                        </div>
                      </div>

                      <div className="flex-grow-1 overflow-hidden">
                        <p className="mb-1 text-truncate text-muted">
                          Responsável
                        </p>
                        <h5 className="font-size-16 mb-0">Jane Doe</h5>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default Team;
